export default {"src":"/_next/static/media/facebook-social.97a9807f.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};